import { application } from "./application";
import "../../components";

import AddressAutocompleteController from "../controllers/address_autocomplete_controller";
application.register("address-autocomplete", AddressAutocompleteController);

import AffiliateAssignmentController from "../controllers/affiliate_assignment_controller";
application.register("affiliate-assignment", AffiliateAssignmentController);

import RevenueSplitController from "../controllers/revenue_split_controller";
application.register("revenue-split", RevenueSplitController);

import AngleDirectionController from "../controllers/angle_direction_controller";
application.register("angle-direction", AngleDirectionController);

import AppNavigationController from "./app_navigation_controller";
application.register("app-navigation", AppNavigationController);

import AutoMailingEditorController from "../controllers/auto_mailing_editor_controller";
application.register("auto-mailing-editor", AutoMailingEditorController);

import AutomaticFormSubmitController from "../controllers/automatic_form_submit_controller";
application.register("automatic-form-submit", AutomaticFormSubmitController);

import ChargingPreferenceController from "./charging_preference_controller";
application.register("charging-preference", ChargingPreferenceController);

import ControlThresholdController from "../controllers/control_threshold_controller";
application.register("control-threshold", ControlThresholdController);

import FuseLimitController from "../controllers/fuse_limit_controller";
application.register("fuse-limit", FuseLimitController);

import ClickableRowController from "../controllers/clickable_row_controller";
application.register("clickable-row", ClickableRowController);

import ClipboardController from "../controllers/clipboard_controller";
application.register("clipboard", ClipboardController);

import ConditionalFieldController from "../controllers/conditional_field_controller";
application.register("conditional-field", ConditionalFieldController);

import ConfirmNameController from "./confirm_name_controller";
application.register("confirm-name", ConfirmNameController);

import ContactWidgetController from "../controllers/contact_widget_controller";
application.register("contact-widget", ContactWidgetController);

import DetailsAutoCloseController from "../controllers/details_auto_close_controller";
application.register("details-auto-close", DetailsAutoCloseController);

import ConfirmWithInputController from "../controllers/confirm_with_input_controller";
application.register("confirm-with-input", ConfirmWithInputController);

import CustomEventController from "../controllers/custom_event_controller";
application.register("custom-event", CustomEventController);

import DarkModeController from "../controllers/dark_mode_controller";
application.register("dark-mode", DarkModeController);

import DisableSubmitController from "../controllers/disable_submit_controller";
application.register("disable-submit", DisableSubmitController);

import ElectricityPlanController from "../controllers/electricity_plan_controller";
application.register("electricity-plan", ElectricityPlanController);

import ChargePointModelSuggestionsController from "./charge_point_model_suggestions_controller";
application.register("charge-point-model-suggestions", ChargePointModelSuggestionsController);

import FadeOutController from "./fade_out_controller";
application.register("fade-out", FadeOutController);

import FileUploadController from "./file_upload_controller";
application.register("file-upload", FileUploadController);

import ChosenEntryController from "../controllers/chosen_entry_controller";
import FilterableListController from "../controllers/filterable_list_controller";
application.register("chosen-entry", ChosenEntryController);
application.register("filterable-list", FilterableListController);

import GoogleAnalyticsController from "../controllers/google_analytics_controller";
application.register("google-analytics", GoogleAnalyticsController);

import HideSectionController from "../controllers/hide_section_controller";
application.register("hide-section", HideSectionController);

import OcppGatewayTimeoutController from "./ocpp_gateway_timeout_controller";
application.register("ocpp-gateway-timeout", OcppGatewayTimeoutController);

import PreSelectInputController from "../controllers/pre_select_input_controller";
application.register("pre-select-input", PreSelectInputController);

import OmniSearchController from "./omni_search_controller";
application.register("omni-search", OmniSearchController);

import PairingStepsController from "./pairing_steps_controller";
application.register("pairing-steps", PairingStepsController);

import SerialNumberController from "./serial_number_controller";
application.register("serial-number", SerialNumberController);
import ChargerIdPreviewController from "./charger_id_preview_controller";
application.register("charger-id-preview", ChargerIdPreviewController);

import ClipboardFeedbackController from "./clipboard_feedback_controller";
application.register("clipboard-feedback", ClipboardFeedbackController);

import QuantileSliderController from "../controllers/quantile_slider_controller";
application.register("quantile-slider", QuantileSliderController);

import SectionToggleController from "../controllers/section_toggle_controller";
application.register("section-toggle", SectionToggleController);

import SegmentPromptController from "../controllers/segment_prompt_controller";
application.register("segment-prompt", SegmentPromptController);

import SentryController from "../controllers/sentry_controller";
application.register("sentry", SentryController);

import SliderInputController from "../controllers/slider_input_controller";
application.register("slider-input", SliderInputController);

import SolarArrayPreviewController from "../controllers/solar_array_preview_controller";
application.register("solar-array-preview", SolarArrayPreviewController);

import SpreadsheetColumnsController from "../controllers/spreadsheet_columns_controller";
application.register("spreadsheet-columns", SpreadsheetColumnsController);

import SubmitOnMetaEnterController from "../controllers/submit_on_meta_enter_controller";
application.register("submit-on-meta-enter", SubmitOnMetaEnterController);

import SessionGraphController from "./session_graph_controller";
application.register("session-graph", SessionGraphController);

import ToggleController from "./toggle_controller";
application.register("toggle", ToggleController);

import ToggleVisibilityController from "./toggle_visibility_controller";
application.register("toggle-visibility", ToggleVisibilityController);

import DigitalTwinController from "../controllers/digital_twin_controller";
application.register("digital-twin", DigitalTwinController);

import PlanningExplorerController from "./planning_explorer_controller";
application.register("planning-explorer", PlanningExplorerController);

import LineNumbersController from "../controllers/line_numbers_controller";
application.register("line-numbers", LineNumbersController);

import MailingPreviewController from "../controllers/mailing_preview_controller";
application.register("mailing-preview", MailingPreviewController);

import MailingVariableParityController from "../controllers/mailing_variable_parity_controller";
application.register("mailing-variable-parity", MailingVariableParityController);

import MarkdownToolbarController from "../controllers/markdown_toolbar_controller";
application.register("markdown-toolbar", MarkdownToolbarController);

import ScenarioGroupsController from "../controllers/scenario_groups_controller";
application.register("scenario-groups", ScenarioGroupsController);

import TreePreviewController from "../controllers/tree_preview_controller";
application.register("tree-preview", TreePreviewController);

import ChartRowController from "../controllers/chart_row_controller";
application.register("chart-row", ChartRowController);

import ChartSolverController from "../controllers/chart_solver_controller";
application.register("chart-solver", ChartSolverController);
